<template>
    <md-content>
        <p><span v-if="saving">saving...</span>
        <span v-else>saved</span>
        </p>
        <md-button class="md-primary md-raised" @click="print">Print</md-button>

        <md-button v-on:click="exportUnitPlan">Export JSON</md-button>
        <md-button class="md-accent" v-on:click="showDeleteUnitPlan=true">Delete Unit Plan</md-button>
        <md-dialog-confirm
          :md-active.sync="showDeleteUnitPlan"
          md-title="Delete Unit Plan?"
          :md-content="'This will delete the unit plan '+unitPlan.name+'. Are you sure you want to continue?'"
          md-confirm-text="Delete"
          md-cancel-text="Cancel"
          @md-confirm="deleteUnitPlan" />
        <md-button class="md-accent" v-on:click="updateSchema">Update UnitPlan</md-button>
        <md-field md-inline>
        <label>Title</label>
        
        <md-input v-model="unitPlan.name"></md-input>
        </md-field>
        <span v-if="!start_date">
          This should be blank. There's no date set.
          </span>
        <md-datepicker v-model="start_date">
          <label>Start Date</label>
        </md-datepicker>
        <md-card  v-for="(section, idx) in unitPlan.sections" :key="idx">
            <md-card-header class="md-display-1">{{ section.title }}</md-card-header>           
                <md-card-content>
                <component 
                v-for="(item, idx2) in section.fields" 
                :key="idx2" 
                :is="dynamicFieldComponent(item.type)"
                :field="item"
                v-model="item.data"></component>
                </md-card-content>
        </md-card>
        
    <md-card>
        <!-- <weekly-plan :weeklyPlan="selectedWeeklyPlan" :dailyPlans="null" ></weekly-plan> -->
        <md-card-header class="md-display-3">Weekly Plan</md-card-header>
        <md-tabs md-sync-route>
            <md-tab v-for="(weeklyPlan, idx) in unitPlan.weeklyPlans" 
            :key="idx" 
            :id="idx.toString()" 
            :md-label="getWeekTabText(idx)"
            :to="getWeekRoute(idx)">
              
              <!-- Week component -->

              <weekly-plan :unitPlan=unitPlan :weekNum=idx :weeklyPlan.sync=weeklyPlan :dailyPlans="dailyPlanSlice(idx)"></weekly-plan>
            </md-tab>
            <md-tab id="add-tab" md-label="+new" v-on:click="createWeeklyPlanClicked"></md-tab>
        </md-tabs>
        
        </md-card>
    </md-content>
</template>

<script>
const WEEKLENGTH=5
export const FIELDTYPES = {
  text: "UnitPlanTextField",
  text_array: "TextArray",
  standards_select: "UnitPlanStandardsSelectField",
};
import { db } from "../main";
import _ from "lodash";
import UnitPlanTextField from "../components/UnitPlanTextField";
import TextArray from "../components/TextArray";
import WeeklyPlan from "../views/WeeklyPlan";
import firebase from 'firebase/app'
import { updateUnitPlan } from '../models/UnitPlan'
// import UnitPlanStandardsSelectField from '../components/UnitPlanSelectField'
import UnitPlanStandardsSelectField from "../components/UnitPlanStandardsSelectFieldAlt1";
// import { createWeeklyPlan } from "../models/UnitPlan";
import weeklyplantemplate from '../data/weeklyplantemplate.json';
import dailyplantemplate from '../data/dailyplantemplate.json';
//import UnitPlanPrintView from '../components/UnitPlanPrintView'
import moment from 'moment'
export default {
  components: {
    UnitPlanTextField,
    UnitPlanStandardsSelectField,
    WeeklyPlan,
    TextArray
  },
  data() {
    return {
      unitPlan: {dailyPlans: [], weeklyPlans: []},
      start_date: null,
      saving: false,
      showDeleteUnitPlan: false,
      showDeleteWeek: false,
      showPrint: false,
    };
  },
  firestore() {
    return {
      unitPlan: db.collection("unitPlans").doc(this.$route.params.id),
    };
  },
  computed: {
    
  },
  methods: {
    dailyPlanSlice: function(nWeek) {
      //extract the 5 element slice. Slice does a shallow copy, but these are objects.
      if((this.unitPlan.dailyPlans.length >= nWeek * WEEKLENGTH+WEEKLENGTH))
        return this.unitPlan.dailyPlans.slice(nWeek*WEEKLENGTH, nWeek*WEEKLENGTH+WEEKLENGTH)
      else
        return this.unitPlan.dailyPlans.slice(nWeek*WEEKLENGTH)
    },
    goToWeek(nWeek) {
      this.$router.push({
        name: "unit-plan-week",
        params: { id: this.unitPlan.id, weeknum: nWeek }
      });
    },
    getWeekRoute(nWeek) {
      return "/unit-plan/" + this.unitPlan.id + "/week/" + nWeek;
    },
    dynamicFieldComponent(type) {
      return FIELDTYPES[type];
    },
    getWeekTabText(nWeek) {
      return moment(this.start_date).add({weeks: nWeek}).format('MM/DD')
    },
    save: _.debounce(function() {
      //the thing
      this.saving = false;
      console.log("saved")
      db
        .collection("unitPlans")
        .doc(this.$route.params.id)
        .set(this.unitPlan);
    }, 2000),
    createWeeklyPlan: function() {
      //Test if Weekly and daily plans keys exist:
      if(!("weeklyPlans" in this.unitPlan))
        this.unitPlan.weeklyPlans = [];
      if(!("dailyPlans" in this.unitPlan))
        this.unitPlan.dailyPlans = [];
      var week_template = JSON.parse(JSON.stringify(weeklyplantemplate));
      var day_template_str = JSON.stringify(dailyplantemplate);
      this.unitPlan.weeklyPlans.push(week_template);
      // How many days to create?
      let days_to_create = this.unitPlan.weeklyPlans.length*WEEKLENGTH - this.unitPlan.dailyPlans.length;
      console.log("creating days: " + days_to_create)
      for(let i = 0; i < days_to_create; i++)
      {
        this.unitPlan.dailyPlans.push(JSON.parse(day_template_str))
      }
    },
    exportUnitPlan: function() {
      var filename = this.unitPlan.name;
      var blob = new Blob([JSON.stringify(this.unitPlan)], {type: 'text/plain'});
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
      } else{
          var e = document.createEvent('MouseEvents'),
          a = document.createElement('a');
          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
          e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          a.dispatchEvent(e);
      }
    },
    deleteUnitPlan: function() {
      console.log("delete unit plan")
      db
        .collection("unitPlans")
        .doc(this.$route.params.id)
        .delete()
      this.$router.replace('/')
      

    },
    createWeeklyPlanClicked: function() {
      this.createWeeklyPlan();
    },
    print: function(){
      window.open('/#/unit-plan/' + this.unitPlan.id+'/print','_blank')
    },
    updateSchema: function() {
      console.log("updating...")
      //Attempt to update the unit plan schema. Potentially very dangerous!
      updateUnitPlan(this.unitPlan)


    }
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    if (from.params.id != to.params.id) {
      if(this.saving==true){ // Here we check if saving. If so, call the before route update again
        next(false)
        return
      }
      else{
        this.$unbind("unitPlan")
        this.unitPlan = {dailyPlans: [], weeklyPlans: []}
        this.$bind("unitPlan", db.collection("unitPlans").doc(to.params.id));
      }
    }
    next()
  },
  watch: {
    unitPlan: {
      handler: function(newUnitPlan) {
        if (newUnitPlan.start_date == null){
          this.start_date = null
        }
        else {
          var newDate = newUnitPlan.start_date.toDate()
          if (this.start_date == null)
            this.start_date = newDate
          else if (newDate.getTime() != this.start_date.getTime())
          {
            console.log("Dates different, setting local date")
            this.start_date = newUnitPlan.start_date.toDate()
          }
          else{
            console.log(newUnitPlan.start_date)
            console.log("Dates were the same")
          }
        }
        this.saving = true;
        console.log("saving");
        this.save();
      },
      deep: true
    },
    start_date: {
      handler: function(newDate) {
        if (newDate == null)
          {
            this.unitPlan.start_date = null
            console.log("null date")
          }
        else
          this.unitPlan.start_date = firebase.firestore.Timestamp.fromDate(newDate)
      }
    }
  }
};
</script>

<style scoped>

.day-row {
  height: 400px;
}
.md-card {
  margin: 20px;
  vertical-align: top;
}

.spinner {
  margin: 100px auto 0;
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 18px;
  height: 18px;
  background-color: #333;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/UnitPlan.vue